import { stateStatusType, VideoSeriesProps } from './actionType';

// FetchVideoSeriesState
export interface FetchVideoSeriesState {
    isLoading: boolean;
    error: string | null;
    video_series: VideoSeriesProps[];
    status: stateStatusType | null;
}
export interface GenericVideoSeriesState {
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}

export const initialVideoSeriesState: FetchVideoSeriesState = {
    isLoading: false,
    error: null,
    video_series: [],
    status: null
};

export const initialGenericVideoSeriesState: GenericVideoSeriesState = {
    isLoading: false,
    error: null,
    status: null
};

export interface VideoSeriesState {
    videoSeriesState: FetchVideoSeriesState;
    genericVideoSeriesState: GenericVideoSeriesState;
}

export const initialState: VideoSeriesState = {
    videoSeriesState: initialVideoSeriesState,
    genericVideoSeriesState: initialGenericVideoSeriesState,
};


